import { EvaluationApi, UpdateEvaluationDTO } from "../Api";
import { getAuthConfiguration } from "./configuration";

const AuthEvaluationApiFactory = () =>
	new EvaluationApi(getAuthConfiguration());

export const getEvaluationByUserId = async (userId: string, year: number) => {
	const response =
		await AuthEvaluationApiFactory().apiEvaluationGetUsersEvaluationByYearUserIdGet(
			{
				userId: userId,
				year: year,
			}
		);
	return response;
};

export const addEvaluation = (
	updateEvaluationDTO: UpdateEvaluationDTO,
	userId: string
) => {
	return AuthEvaluationApiFactory().apiEvaluationAddEvaluationPost({
		updateEvaluationDTO,
	});
};

export const updateEvaluation = (
	id: string,
	updateEvaluationDTO: UpdateEvaluationDTO
) => {
	return AuthEvaluationApiFactory().apiEvaluationUpdateEvaluationIdPut({
		id,
		updateEvaluationDTO,
	});
};
